import LabelIcon from '@mui/icons-material/Label';
import { observer } from 'mobx-react';
import React from 'react';
import { InputAdornment, TextField } from 'lib/cortiUI';
import { FormElementWidget } from './FormElementWidget';
export const FlowValueCollectorElementWidget = observer(({ model }) => {
    return (React.createElement(FormElementWidget, { model: model, skipToolbar: true },
        React.createElement(TextField, { disabled: true, fullWidth: true, value: "", InputProps: {
                endAdornment: (React.createElement(InputAdornment, { position: "end" },
                    React.createElement(LabelIcon, { fontSize: "small" }))),
            } })));
});
